import React from 'react';
import { ObjectType } from '~entities/Object';
import FavoriteButton from '~components/FavoriteButton';

export type Props = {
  id: ObjectType['id_crm'];
  toggleFavorite: (id: ObjectType['id_crm']) => void;
  hasFavorites: (id: ObjectType['id_crm']) => boolean;
};

const TableFavoriteButton = ({ id, toggleFavorite, hasFavorites }: Props) => {
  const handleClick = () => {
    toggleFavorite(id);
  };

  return (
    <FavoriteButton
      onClick={handleClick}
      isActive={hasFavorites(id)}
      size={22}
    />
  );
};

export default TableFavoriteButton;
